export const PROCEDIMENTOS_NORMAS_FIND_ONE = 'PROCEDIMENTOS_NORMAS_FIND_ONE';
export const PROCEDIMENTOS_NORMAS_FIND_ONE_SUCCESS = 'PROCEDIMENTOS_NORMAS_FIND_ONE_SUCCESS';

export const PROCEDIMENTOS_NORMAS_CREATE = 'PROCEDIMENTOS_NORMAS_CREATE';
export const PROCEDIMENTOS_NORMAS_CREATE_SUCCESS = 'PROCEDIMENTOS_NORMAS_CREATE_SUCCESS';

export const PROCEDIMENTOS_NORMAS_UPDATE = 'PROCEDIMENTOS_NORMAS_UPDATE';
export const PROCEDIMENTOS_NORMAS_UPDATE_SUCCESS = 'PROCEDIMENTOS_NORMAS_UPDATE_SUCCESS';

export const PROCEDIMENTOS_NORMAS_CLEAN = 'PROCEDIMENTOS_NORMAS_CLEAN';
export const PROCEDIMENTOS_NORMAS_CLEAR_SELECTED = 'PROCEDIMENTOS_NORMAS_CLEAR_SELECTED';

export const PROCEDIMENTOS_NORMAS_CANCEL_STATUS = 'PROCEDIMENTOS_NORMAS_CANCEL_STATUS';
export const PROCEDIMENTOS_NORMAS_CANCEL_STATUS_SUCCESS = 'PROCEDIMENTOS_NORMAS_CANCEL_STATUS_SUCCESS';

export const PROCEDIMENTOS_NORMAS_CONFIRM_STATUS = 'PROCEDIMENTOS_NORMAS_CONFIRM_STATUS';
export const PROCEDIMENTOS_NORMAS_CONFIRM_STATUS_SUCCESS = 'PROCEDIMENTOS_NORMAS_CONFIRM_STATUS_SUCCESS';

export const PROCEDIMENTOS_NORMAS_REPORT = 'PROCEDIMENTOS_NORMAS_REPORT';